import { useEffect, useState } from 'react';
import { Logger}  from "@utils/logger";

const cachedScripts: Array<string> = [];
// Imported from https://usehooks.com/useScript/

export const useScript = (src: string) => {
	// Keeping track of script loaded and error state
	const [state, setState] = useState({
		loading: false,
		loaded: false,
		error: false
	});

	useEffect(() => {
			// If cachedScripts array already includes src that means another instance ...
			// ... of this hook already loaded this script, so no need to load again.
			setState({
				loading: true,
				loaded: false,
				error: false
			});
			if (cachedScripts.includes(src)) {
				setState({
					loading: false,
					loaded: true,
					error: false
				});
			} else {
				cachedScripts.push(src);

				// Create script
				const script = document.createElement('script');
				script.setAttribute('src', src);
				script.setAttribute('async', "true");
				script.setAttribute('type', 'text/javascript');

				// Script event listener callbacks for load and error
				const onScriptLoad = () => {
					setState({
						loading: false,
						loaded: true,
						error: false
					});
				};

				const onScriptError = (event: any) => {
					Logger.error(`An error occurred while loading the script from src: ${src}. Error: `, event);
					// Remove from cachedScripts we can try loading again
					const index = cachedScripts.indexOf(src);
					if (index >= 0) cachedScripts.splice(index, 1);
					script.remove();

					setState({
						loading: false,
						loaded: true,
						error: true
					});
				};

				script.addEventListener('load', onScriptLoad);
				script.addEventListener('error', onScriptError);

				// Add script to document body
				document.body.appendChild(script);

				// Remove event listeners on cleanup
				return () => {
					script.removeEventListener('load', onScriptLoad);
					script.removeEventListener('error', onScriptError);
				};
			}

			return () => {};
		}, [src]);

	return [state.loaded, state.error, state.loading];
}
